import React from "react";
import { useNavigate } from "react-router-dom";

import liikemerkki from "./img/liikemerkki_168.png";

const Liikemerkki = (props) => {
  const { asetatila } = props;
  const navigate = useNavigate();

  function handleClick(event) {
    document.getElementById("hakuLaatikko").value = "";
    document.getElementById("kaikki").checked = true;
    asetatila("haku", { sivu: 0 });
    navigate("/");
  }
  return (
    <img
      src={liikemerkki}
      alt="Liikemerkki"
      className="liikemerkki"
      id="Liikemerkki"
      onClick={handleClick}
    />
  );
};
export default Liikemerkki;
